/**
 * Wohin die Vegetationsliste im Protokoll-PDF kommt (Nutzer-Befund 25.09.2026:
 * eine lange Liste schrieb sich ueber den Abkuerzungs-Fusstext, und was unter
 * den Seitenrand geriet, fehlte ganz).
 *
 * Alle Masse in mm. `platzHier` ist, was auf der laufenden Seite ueber dem
 * Fusstext noch frei ist, `platzFrisch` dasselbe auf einer leeren Seite.
 * Ohne Angular und ohne jsPDF, damit die Regel fuer sich pruefbar ist.
 */
export interface VegetationBedarf {
	/** Hoehe des ganzen Abschnitts einspaltig (Ueberschrift, Anteile, Kopf, alle Zeilen). */
	einspaltig: number;
	/** Dasselbe zweispaltig; `Infinity`, wenn zwei Spalten keinen Sinn haben (eine Zeile). */
	zweispaltig: number;
	platzHier: number;
	platzFrisch: number;
	/** So viel muss mindestens passen, damit es sich lohnt, hier anzufangen (Kopf + ein paar Zeilen). */
	mindestens: number;
}

export interface VegetationLage {
	/** Vor dem Abschnitt eine neue Seite anfangen. */
	neueSeite: boolean;
	spalten: 1 | 2;
	/** Passt nirgends am Stueck: einspaltig, und die Zeilen brechen um, wo die Seite endet. */
	umbruch: boolean;
}

/**
 * Reihenfolge der Wuensche: auf der laufenden Seite bleiben (einspaltig, sonst
 * zweispaltig), sonst auf einer neuen Seite (einspaltig, sonst zweispaltig),
 * sonst einspaltig mit Umbruch je Zeile. Zwei Spalten gehen einer neuen Seite
 * vor, weil sie die Seite sparen; auf einer neuen Seite geht eine Spalte den
 * zweien vor, weil sie leichter zu lesen ist.
 */
export function vegetationLayout(b: VegetationBedarf): VegetationLage {
	if (b.einspaltig <= b.platzHier) return { neueSeite: false, spalten: 1, umbruch: false };
	if (b.zweispaltig <= b.platzHier) return { neueSeite: false, spalten: 2, umbruch: false };
	if (b.einspaltig <= b.platzFrisch) return { neueSeite: true, spalten: 1, umbruch: false };
	if (b.zweispaltig <= b.platzFrisch) return { neueSeite: true, spalten: 2, umbruch: false };
	// Hier anfangen, wenn wenigstens ein paar Zeilen Platz haben - sonst
	// stuende eine Ueberschrift allein am Seitenende.
	return { neueSeite: b.mindestens > b.platzHier, spalten: 1, umbruch: true };
}
